//* 포커스 링 — 클릭 가능한 모든 표면이 공유하는 유일한 값. 색이 의미를 갖는 표면(선택된 행,
//* 기준선 강조 등)도 포커스 표시만은 같아야 해서 hover/active와 달리 예외가 없다.
//* 앱 `outline-*` 16종 · DS `ring-*` 14종으로 갈려 있던 것을 여기로 모은다.
//* `-outline-offset`인 이유: 카드·행은 `overflow-hidden` 부모 안에 있는 경우가 많아 바깥 offset이 잘린다.
export const FOCUS_RING =
  'focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-B-500';

//* 배경이 비어 있는 행·카드의 상태 피드백 한 세트. 자체 배경으로 상태를 표현하는 표면
//* (선택 칩·강조 행·이미지 타일)엔 쓰지 않는다 — 그쪽은 색이 곧 의미라 덮으면 안 되고
//* `FOCUS_RING`만 가져다 쓴다. 버튼은 둘 다 아니라 DS `Button`을 쓴다.
//* Tailwind가 content 스캔으로 클래스를 찾으므로 FOCUS_RING을 문자열 보간하지 않고 펼쳐 적는다.
export const INTERACTIVE_SURFACE =
  'transition-colors duration-150 motion-reduce:transition-none hover:bg-Gray-50 active:bg-Gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-B-500';
